// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"34":"90e4a143","425":"9099b10a","566":"94d83161"}[chunkId] + ".chunk.css";
};